(function () {
  'use strict';

  function initBanner(banner) {
    var content   = banner.querySelector('.qt-hero-banner__content');
    var leftDeco  = banner.querySelector('.qt-hero-banner__deco--left');
    var rightDeco = banner.querySelector('.qt-hero-banner__deco--right');

    if (!content || (!leftDeco && !rightDeco)) return;

    var decos = [leftDeco, rightDeco].filter(Boolean);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            decos.forEach(function (el) {
              el.classList.remove('is-out');
              el.classList.add('is-in');
            });
          } else {
            decos.forEach(function (el) {
              el.classList.remove('is-in');
              el.classList.add('is-out');
            });
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(content);
  }

  function init() {
    document.querySelectorAll('[data-qt-hero-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
